module.exports = __webpack_public_path__ + "static/media/pay-top-success4.0ad2ea74.png";